import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarTodasOrigensClientes(api) {
    let parametros = {
      operacao: 'buscarTodasOrigensClientes'
    }

    let retorno = {};

    await api.santriGET('/rest/origemCliente', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },

  async buscarOrigemClientePorId(api, parametros) {
    parametros.operacao = 'buscarOrigemClientePorId';

    let retorno = {};

    await api.santriGET('/rest/origemCliente', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrigemCliente.js